export default "__VITE_ASSET__DUjBcZSJ__"